// extracted by mini-css-extract-plugin
export default {"wrapper":"Wrapper_wrapper__MC5CJ","title":"Wrapper_title__nGMD0","review_menu":"Wrapper_review_menu__sobBO"};